import * as amplitude from '@amplitude/analytics-browser';
import ooeConstants from '../constants';

export const setupAmplitude = () => {
  if (!ooeConstants.AMPLITUDE_ENABLED) {
    // eslint-disable-next-line no-console
    console.debug('IN setupAmplitude, AMPLITUDE NOT ENABLED');
    return;
  }

  amplitude.init(ooeConstants.AMPLITUDE_API_KEY, {
    appVersion: ooeConstants.APP_VERSION,
    cookieOptions: {
      secure: true,
    },
  });
};

export const logAmplitudeEvent = (eventName, eventProperties) => {
  if (!ooeConstants.AMPLITUDE_ENABLED) {
    // eslint-disable-next-line no-console
    console.debug('IN logAmplitudeEvent, AMPLITUDE NOT ENABLED');
    return;
  }

  if (!eventName) {
    // eslint-disable-next-line no-console
    console.warn('logAmplitudeEvent called without eventName');
    return;
  }

  amplitude.track(eventName, eventProperties);
};
